export default "__VITE_ASSET__CdrSNOBS__"